import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from "@angular/common/http"
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { AngularFireDatabase } from "@angular/fire/compat/database";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { MessagingService } from "./../../../services/messaging.service";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from "@angular/forms";
import { Observable } from "rxjs";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { AdminService } from "src/app/services/admin.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { apiUrl } from "../../../global/global";
import * as CONSTANT from "src/app/services/constants";
import { ChatService } from "src/app/services/chat.service";
import { ImageUrls } from "src/app/services/s3buket";
import { Lightbox } from "ngx-lightbox";
import { CompressImageService } from "src/app/services/compress-image.service";
import { take } from "rxjs/operators";
import swal from "sweetalert2";
import { chatEnvironment } from "../../../../environments/chatEnvironment";
import { DataSharingService } from "src/app/services/data.share.service";

@Component({
  selector: "app-message-detail",
  templateUrl: "./message-detail.component.html",
  styleUrls: ["./message-detail.component.css"]
})
export class MessageDetailComponent implements OnInit {
  firebaseUsers = chatEnvironment.users;
  firebaseMessage = chatEnvironment.messages;
  deleteMessages = chatEnvironment.deleteMessages;
  firebaseChats = chatEnvironment.chats;
  firebaseJobs = chatEnvironment.jobs;
  firebaseNotification = chatEnvironment.notifications;
  @ViewChild("messagesListContainer") private messageListContainer?: ElementRef;

  dialogListing: any = [];
  chatDialog: any = [];
  messageData: any = [];
  firebaseMsg: any = [];
  messagesList: any = [];
  userMessage1: any;
  modalRef9: any;
  baseUrl;
  user_name;
  profile_pic;
  chat_dialog_id: any = "";
  job_dialog_id: any = "";
  delete_status: any;
  clear_chat_time: any;
  job_id;
  user_id;
  Chats: Observable<any[]>;
  Messages: Observable<any[]>;
  public userMessage: string = "";
  chatFileName: any;
  private messageListener: any;
  private allMsgListener: any;
  un_read_message_count;
  block_unblock: any;
  block_unblock_text: any;
  block_unblock_header: any;
  block_message: any;
  block_message_payment: any;
  block_message_payment_dec: any;
  block_message_payment_m: any;
  other_block_unblock: any;
  //lastMessageTimeOther : any;
  last_message_other: any;
  last_message_time: any;
  last_message: any;
  //otherUserName : any;
  items_copy: any;
  jobId: any;
  other_user_unread_count: any;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users;
  fileView: any;
  uploadFile: any;
  uploadType = 0;
  fileType: any;
  addResponsiveClass: any;
  modalScrollDistance = 2;
  modalScrollThrottle = 50;
  totalCount: any;
  userId: string = "";
  chatListSearchBy: string = "";
  chatListFilterBy: string = "";
  _albums: any;
  mediaInfo = [];
  msgId: any;
  apiloadData:any=[];
  private delMessageListener: any;
  checkBlockStatus: any;
  constructor(private compressImage: CompressImageService, private dataSharingService: DataSharingService, private modalService: BsModalService, private route: ActivatedRoute, private chatService: ChatService, private router: Router, private db: AngularFireDatabase, private afAuth: AngularFireAuth, private messagingService: MessagingService, private formBuilder: FormBuilder, private storage: AngularFireStorage, private api: AdminService, private http: HttpClient, private handler: HttpBackend, private toastrService: ToastrService, private _lightbox: Lightbox, private _lightboxGallery: Lightbox) {
    this.route.queryParams.subscribe((params) => {
      if (params.dialog_id) {
        this.chat_dialog_id = params.dialog_id
        this.job_dialog_id = params.job_id
        this.getChatHistory(params.dialog_id, params.job_id, params.user_id, params.user_name, params.profile_pic)
        this.getchatFromAPI(params.dialog_id, params.job_id);
        this.getMessages(params.dialog_id);      
        this.getChatsDialog(params.dialog_id);
      }
    })
    this.Chats = this.chatService.Chats;
    this.Messages = this.chatService.ChatMessages;
  }

  ngOnInit(): void {
    localStorage.removeItem('newchat')
    this.jobId = this.route.snapshot.paramMap.get("id");
    this.getJobDialogs(this.jobId);
    this.baseUrl = this.globalUrl
  }

  public sendMessage(event) {
    if (this.uploadFile != null && this.uploadType != null) {
      if (event.srcElement["blockUnblockStatusSend"].value == 0) {
        if (event.srcElement["myblock_status_send_message"].value == 0) {
          this.uploadFileToS3(this.uploadFile, this.uploadType);
          this.uploadFile = null;
          this.uploadFile.value = null;
        } else {
          this.toastrService.error("This person has  blocked you.", "", {
            timeOut: 5000,
          });
          this.fileView = "";
        }
      } else {
        this.toastrService.error("You has blocked this person. To continue, you need to unblock this person.", "", {
          timeOut: 5000,
        });
        this.fileView = "";
      }
    }

    if (event.srcElement["userMessage"].value.toString().trim() != "") {
      if (event.srcElement["blockUnblockStatusSend"].value == 0) {
        if (event.srcElement["myblock_status_send_message"].value == 0) {
          this.scrollToBottom();
          this.changeDeleteDialogStatus(false);
          this.chatService.sendMessage(event.srcElement["userMessage"].value.toString().trim(), event.srcElement["chatDiologId"].value, event.srcElement["jobId"].value, event.srcElement["userId"].value, event.srcElement["unReadMessageCount"].value, event.srcElement["myblock_status_send_message"].value, event.srcElement["lastMessageTimeOthertext"].value, event.srcElement["lastMessageOthertext"].value, event.srcElement["otherUserUnreadCounttext"].value)
          event.srcElement["userMessage"].value = "";
        } else {
          this.toastrService.error("This person has blocked you.", "", {
            timeOut: 5000,
          });
          event.srcElement["userMessage"].value = "";
        }
      } else {
        this.toastrService.error("You has blocked this person. To continue, you need to unblock this person.", "", {
          timeOut: 5000,
        });
        event.srcElement["userMessage"].value = "";
      }
    }
  }
  getJobDialogs(job_id: string) {
    this.db.list(`${this.firebaseChats}`,
      query => query
        .orderByChild("job_id")
        .equalTo(job_id)
    ).valueChanges().subscribe(listNew => {
      this.dialogListing = Object.assign([], listNew)
      this.dialogListing = this.dialogListing.filter(x => x.delete_status ? x.delete_status[job_id] == 0 : true);
      this.dialogListing = this.dialogListing.sort((a, b) => b["last_message_time"] - a["last_message_time"]);
      this.totalCount = this.dialogListing.length;
      if (this.chat_dialog_id !== "") {
        const filter_array = this.dialogListing.filter(x => x.chat_dialog_id == this.chat_dialog_id);
        if (filter_array?.length == 0) {
          this.messageData = "";
          this.router.navigate(["/message"])
        }
      }
    });
 
  }


  selectedUser(i, event) {
    console.log(event)
    this.dialogListing.map((user) => {
      user["selected"] = false;
    })
    this.dialogListing[i]["selected"] = true;
  }


  onFilterChatList(filterType: string) {
    if (filterType === "unread") {
      this.dialogListing = this.dialogListing.filter(res => {
        let id = res.job_id;
        return res.unread_count[id] > 0
      })
    } else {
      this.getJobDialogs(this.jobId);
    }
    // this.chatListFilterBy = filterType;
  }

  backToList() {
    this.addResponsiveClass = "";
  }
  getChatHistory(chat_dialog_id, job_id, user_id, user_name, dialog) {
    this.addResponsiveClass = "1";
    this.chat_dialog_id = chat_dialog_id;
    this.user_name = user_name;
    this.profile_pic = dialog?.pic?dialog?.pic[dialog?.user_id]:'';
    this.job_id = job_id;
    this.user_id = user_id;
    if (this.chat_dialog_id != "") {
      this.getMessages(this.chat_dialog_id);
      this.getChatsDialog(this.chat_dialog_id);
      this.router.navigate(["/message/message-detail/" + job_id],
        { queryParams: { dialog_id: chat_dialog_id, job_id: job_id, user_id: user_id, user_name: user_name, profile_pic: this.profile_pic } })
    }
    this.messageRead(chat_dialog_id)

  }

  messageRead(chat_dialog_id) {
    this.dataSharingService.updateCount.next(true);
    var statusU = this.db.object(`${this.firebaseChats}/${chat_dialog_id}/unread_count`).update({
      [this.job_id]: 0
    });
  }

  getchatFromAPI(chat_dialog_id, job_id) {
    let data = {
      "chatDialogId": chat_dialog_id,
      "jobId": job_id
    }
    this.api.getData(apiUrl._recruiterChats, data).subscribe(async (res) => {
      this.apiloadData = res.data;
      setTimeout(() => {
        this.scrollToBottom();
      }, 100)
      this.api.loader(false)
      this.getMessages(this.chat_dialog_id);
    },
      err => {
        console.log(err, "err");
      });
  }


  getMessages(chat_dialog_id) {
    if (this.allMsgListener) {
      this.allMsgListener.unsubscribe();
    }
    this.allMsgListener = this.db.list(`${this.firebaseMessage}/${chat_dialog_id}`,
      query => query
        .orderByChild("chat_dialog_id")
        .equalTo(chat_dialog_id)
        .limitToLast(1000)
    ).valueChanges().subscribe(list => {
      this.firebaseMsg = Object.assign([], list);
      let sendersId = this.chat_dialog_id.split(',', 2)
      this.firebaseMsg.filter(item => {
        if (item?.receiver_id == '' && sendersId[0] == item?.sender_id) {
          this.db.object(`${this.firebaseMessage}/${chat_dialog_id}/` + item?.message_id).remove();
        } else if (this.job_dialog_id == item?.receiver_id && item?.receiver_id != '') {
          this.db.object(`${this.firebaseMessage}/${chat_dialog_id}/` + item?.message_id).update({
            "receiver_id": ''
          });
        }
        if (item?.message_id) {
          let count = 0;
          this.apiloadData.filter(data => {
            if (item?.message_id == data?.message_id) {
              count = 1;
            }
          })
          if (count == 0) {
            if (item?.chat_dialog_id === this.chat_dialog_id) {
              this.apiloadData.push(item);
            }
          }
        }
      })
      this.messageRead(chat_dialog_id)
      this.messageData = this.apiloadData.sort((a, b) => a['firebase_message_time'] - b['firebase_message_time']);
      setTimeout(() => {
        this.scrollToBottom();
      }, 100)
      this.getDelMessage();
    });

  }
  ngOnDestroy() {
    this.job_dialog_id = '';
    if (this.allMsgListener) {
      this.allMsgListener.unsubscribe();
    }
  }

  getMessageType(message): String {
    if (message.sender_id == this.job_id) {
      if (message?.message_type == 1) {
        return "sent_msg_text"
      } else if (message?.message_type == 2) {
        return "sent_msg_image"
      } else {
        return "sent_msg_pdf"
      }
    } else {
      if (message?.message_type == 1) {
        return "received_msg_text"
      } else if (message?.message_type == 2) {
        return "received_msg_image"
      } else {
        return "received_msg_pdf"
      }
    }
  }
  open(image): void {
    let imageArr: any = []
    imageArr.push({
      src: ImageUrls.BaseUrl + "chatdocuments/" + image,
    })
    this._lightbox.open(imageArr, 0);
  }
  close(): void { // close lightbox programmatically 
    this._lightbox.close();
  }
  getChatsDialog(chat_dialog_id: string) {
    if (chat_dialog_id != "") {
      if (this.messageListener) {
        this.messageListener.unsubscribe();
      }
      this.messageListener = this.db.list(`${this.firebaseChats}`,
        query => query
          .orderByChild("chat_dialog_id")
          .equalTo(chat_dialog_id)
        //.limitToLast(10)
      ).valueChanges().subscribe(list => {
        this.chatDialog = list ? list[0] : [];
        this.un_read_message_count = this.chatDialog.unread_count ? this.chatDialog.unread_count[this.user_id] : 0;
        this.other_block_unblock = this.chatDialog.block_status[this.user_id] ? this.chatDialog.block_status[this.user_id] : 0;
        this.block_unblock = this.chatDialog.block_status[this.job_id] ? this.chatDialog.block_status[this.job_id] : 0;
        this.checkBlockStatus = this.chatDialog.block_status[this.job_id] ? this.chatDialog.block_status[this.job_id] : 0;
        this.block_unblock_text = this.chatDialog.block_status[this.job_id] == 1 ? "Unblock" : "Block";
        this.block_unblock_header = this.chatDialog.block_status[this.job_id] == 1 ? "Unblock" : "Block";
        this.last_message_time = this.chatDialog.last_message_time ? this.chatDialog.last_message_time : 0;
        this.last_message_other = this.chatDialog.last_message ? this.chatDialog.last_message[this.user_id] : "";
        this.last_message = this.chatDialog.last_message ? this.chatDialog.last_message[this.job_id] : "";
        this.other_user_unread_count = this.chatDialog.unread_count ? this.chatDialog.unread_count[this.user_id] : 0;

      });
    }
  }
  onFileSelected(event) {
    if (event.target.files[0].size <= 20000000) {
      const selectedFile = event.target.files[0];
      const idxDot = selectedFile.name.lastIndexOf(".") + 1;
      var extFile = selectedFile.name
        .substr(idxDot, selectedFile.name.length)
        .toLowerCase();
      if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          this.fileView = reader.result as string;
        }
        reader.readAsDataURL(file)
        this.compressedUploadedFile(file, 2)
        event.target.value = null;
      } else if (extFile == "pdf" || extFile == "doc" || extFile == "docx") {
        this.chatFileName = event.target.files[0].name;
        this.fileType = extFile;
        //this.spinner.show();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          this.fileView = reader.result as string;
        }
        reader.readAsDataURL(file)
        // this.compressedUploadedFile(file, 3)
        this.uploadFile = file
        this.uploadType = 3
        event.target.value = null;
      } else {
        this.toastrService.error(
          "Only jpg/jpeg, png, pdf and doc files are allowed!",
          "", {
          timeOut: 5000,
        }
        );
      }
    } else {
      this.toastrService.error("File size exceeds maximum limit 20MB.", "", {
        timeOut: 5000,
      });
    }
  }
  compressedUploadedFile(file, number) {
    this.compressImage.compress(file)
      .pipe(take(1))
      .subscribe(compressedImage => {
        this.uploadFile = compressedImage
        this.uploadType = number
        // now you can do upload the compressed image 
      })
  }
  resetSelectedFile() {
    this.fileView = null;
  }
  uploadFileToS3(fileUpload, x) {
    const data = {
      "directory": "chatdocuments/",
      "fileName": fileUpload.name,
      "contentType": fileUpload.type
    }
    this.api.postData(apiUrl._empUpload, data)
      .subscribe(res => {
        this.http = new HttpClient(this.handler);
        this.http.put<any>(res.data.uploadURL, fileUpload).subscribe(response => {
          this.changeDeleteDialogStatus(false);
          this.chatService.sendMessageDocument(res.data.fileName, this.chat_dialog_id, this.job_id, this.user_id, this.un_read_message_count, this.other_block_unblock, this.last_message_time, this.last_message_other, this.other_user_unread_count, x)
          this.fileView = "";
          this.resetSelectedFile();
          this.scrollToBottom();
        })
      })
  }

  clearChat(chat_dialog_id, job_id, user_id, user_name) {
    swal.fire({
      html: "Are you sure you want to clear the chat history with <strong>" + user_name + "?",
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        var deleteTime = {};
        deleteTime[job_id] = new Date().getTime();
        deleteTime[user_id] = this.chatDialog.clear_chat_time ? this.chatDialog.clear_chat_time[this.user_id] : 0;      
        var chatDialog = this.db.object(`${this.firebaseChats}/${chat_dialog_id}`).update({
          "clear_chat_time": deleteTime,
        });
        var chatDialog = this.db.object(`${this.firebaseChats}/${chat_dialog_id}/last_message`).update({         
          [job_id]:"",
        });
      }
    });
  }

  chatModal(item: TemplateRef<any>, msgId?: any) {
    this.modalRef9 = this.modalService.show(item, { class: "modal-sm modal-dialog-centered" });
    this.msgId = msgId
  }
  blockUnblockUser() {
    console.log("this.checkBlockStatus", this.checkBlockStatus)
    this.db.object(`${this.firebaseChats}/${this.chat_dialog_id}/block_status`).update({
      [this.job_id]: this.checkBlockStatus ? 0 : 1
      // [this.selectedUserChat?.job_id]: jobtype
    });

    if (this.checkBlockStatus) {



      setTimeout(() => {
        this.block_unblock = 0;
        this.block_unblock_text = "Unblock"
        this.block_unblock_header = "Unblock"
        this.checkBlockStatus = 0;
      }, 1000)

    } else {


      setTimeout(() => {
        this.block_unblock = 1;
        this.block_unblock_text = "Block"
        this.block_unblock_header = "Block"
        this.checkBlockStatus = 1;
      }, 1000)
    }
    this.modalRef9.hide();
  }

  deleteUserChat(event) {
  
    if (event) event.preventDefault();
    // chat delete fix
    // if (this.chatDialog.delete_status[this.user_id] == 1) {
    //   this.db.object(`${this.firebaseMessage}/${this.chat_dialog_id}/`).remove();
    //   // this.db.object(`${this.firebaseUsers}/${this.user_id}/`).remove();
    //   // this.db.object(`${this.firebaseJobs}/${this.job_id}/`).remove();
    //   // this.db.object(`${this.firebaseNotification}/${this.chat_dialog_id}/`).remove();
    //   // this.db.object(`${this.firebaseChats}/${this.chat_dialog_id}/`).remove()
    // } else {
      var deleteTime = {};
      deleteTime[this.job_id] = new Date().getTime();
      deleteTime[this.user_id] = this.chatDialog.clear_chat_time ? this.chatDialog.clear_chat_time[this.user_id] : 0;
      var lastMessageArr = {};
      lastMessageArr[this.user_id] = "";
      lastMessageArr[this.job_id] = this.last_message;
      var chatDialog = this.db.object(`${this.firebaseChats}/${this.chat_dialog_id}`).update({
        "clear_chat_time": deleteTime,
      });
      var chatDialog = this.db.object(`${this.firebaseChats}/${this.chat_dialog_id}/last_message`).update({
        [this.job_id] : ""
    })
    var chatDialog = this.db.object(`${this.firebaseChats}/${this.chat_dialog_id}/delete_status`).update({
      [this.job_id] : 1
  })
     

      //this.changeDeleteDialogStatus(true);
    // }
    this.toastrService.success("Chat dialog deleted successfully.", "", {
      timeOut: 5000,
    });
    this.router.navigate(["/message/"])
    this.chat_dialog_id = "";
  }

  changeDeleteDialogStatus(isDelete: boolean) {
    var deleteUserArr = {};
    deleteUserArr[this.job_id] = isDelete ? 1 : 0
    deleteUserArr[this.user_id] = 0
    this.db.object(`${this.firebaseChats}/${this.chat_dialog_id}`).update({
      "delete_status": deleteUserArr
    });
  }
  deleteUserChat1(event) {
    if (event) event.preventDefault();
    this.db.object(`${this.firebaseMessage}/${this.chat_dialog_id}/${this.msgId}`).remove();
    this.toastrService.success("Deleted successfully.", "", { timeOut: 5000 });
    this.router.navigate(["/message/message-detail/" + this.job_id],
      { queryParams: { dialog_id: this.chat_dialog_id, job_id: this.job_id, user_id: this.user_id, user_name: this.user_name, profile_pic: this.profile_pic } })
    const index = this.messageData.findIndex(item => item.message_id === this.msgId)
    this.messageData.splice(index, 1);    
    let delMessageIndex = this.messageData.length>0?this.messageData.length:"";
    if(delMessageIndex){
      if((this.chatDialog.clear_chat_time && this.chatDialog.clear_chat_time[this.job_id]) < (this.messageData[this.messageData.length-1]?.message_time) && (this.chatDialog.chat_dialog_id===this.messageData[this.messageData.length-1]?.chat_dialog_id)){
        delMessageIndex=delMessageIndex;
      }
      else{
        delMessageIndex = ""
      }
    }
    


    this.db.object(`${this.firebaseChats}/${this.chat_dialog_id}`).update({
      "last_message": { [this.job_id]:delMessageIndex ? this.messageData[this.messageData.length-1].message:'', [this.user_id]:delMessageIndex ? this.messageData[this.messageData.length-1].message:'' },
      "last_message_time":delMessageIndex ? Number(this.messageData[this.messageData.length-1].message_time):''
    });
    this.getJobDialogs(this.job_id)
    this.api.loader(false);
    let data = {
      messageIds: [this.msgId]
    }
    this.api.putData(apiUrl._recruiterDeleteMsg, data).subscribe((res) => { })
      var messagePush = this.db.list(`${this.deleteMessages}`).push({})
      var delStatusArr = {};
      delStatusArr[this.msgId] = this.msgId + ',' + this.chat_dialog_id;
      var updateMessage = this.db.object(`${this.deleteMessages}/${this.user_id}`).update(delStatusArr);
      this.msgId = "";
      this.modalRef9.hide();
   
  }

  scrollToBottom(): void {
    this.messageListContainer?.nativeElement.scrollIntoView();
    let shouldScroll = this.messageListContainer?.nativeElement.scrollTop + this.messageListContainer?.nativeElement.clientHeight === this.messageListContainer?.nativeElement.scrollHeight;
    if (!shouldScroll) {
      this.messageListContainer!.nativeElement.scrollTop = this.messageListContainer?.nativeElement?.scrollHeight;
    }
  }

  getDelMessage() {
    if (this.delMessageListener) {
      this.delMessageListener.unsubscribe()
    }
    this.delMessageListener = this.db.list(`${this.deleteMessages}/${this.jobId}`, query => query.limitToLast(10)).valueChanges().subscribe((x: any) => {
      if (x.length > 0) {
        x.map(item => {
          let itemID = item.split(',')[0]
          const index = this.messageData.findIndex(object => {
            return object.message_id === itemID;
          });
          if (index ==0 || index>0) {
            this.messageData.splice(index, 1);
            setTimeout(() => {
              this.db.object(`${this.deleteMessages}/${this.jobId}/${item.split(',')[0]}`).remove();
            }, 50);
          }
        })
      }
    })
    // this.getJobDialogs(this.jobId)
  }


}
